export default __webpack_public_path__ + "static/media/158.05392d2e.svg";